import { render, staticRenderFns } from "./DestekDetayItem.vue?vue&type=template&id=41a7f1aa&scoped=true"
import script from "./DestekDetayItem.vue?vue&type=script&lang=js"
export * from "./DestekDetayItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a7f1aa",
  null
  
)

export default component.exports